import classNames from "classnames";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "./styles.less";

export const ModalUsePortal = (props) => {
  const { onClose, show, children, modalClassName } = props;
  const [target, setTarget] = useState(null);
  useEffect(() => {
    setTarget(document.getElementsByTagName("body")[0]);
  }, []);

  useEffect(() => {}, [show]);

  if (!show) return null; //false 就返回null

  const close = () => {
    onClose();
  };
  const _children = (
    <div className={classNames("mask", modalClassName)}>
      <div className="content">{children}</div>
    </div>
  );
  return target ? ReactDOM.createPortal(_children, target) : null;
};
